// extracted by mini-css-extract-plugin
export var shake = "_15-0";